module.exports = __webpack_public_path__ + "static/media/JP_AS_EYELASHES01.292df036.jpg";